import clsx from "clsx";

import { DateTimeTz, Icon } from "@web-app/components";
import { RouteTimeline } from "@web-app/types";
import { timeZoneMap } from "@web-app/utils/helpers";

type RouteCopyActivityPropsType = {
  item: RouteTimeline;
  showTimelineBar: boolean;
  timezone: keyof typeof timeZoneMap | undefined;
};

export default function RouteCopyActivity({
  item,
  showTimelineBar,
  timezone,
}: RouteCopyActivityPropsType) {
  const isCopiedFrom = !!item.updatedValue;
  const isCopiedTo = !!item.previousValue;

  const getCopyMessage = () => {
    if (isCopiedFrom) {
      return (
        <>
          Route copied{" "}
          <span className="text-black">from {item.updatedValue}</span>
        </>
      );
    }
    if (isCopiedTo) {
      return (
        <>
          Route copied{" "}
          <span className="text-black">to {item.previousValue}</span>
        </>
      );
    }
    return "Route copied";
  };

  return (
    <li key={item.id} className="relative flex gap-x-4">
      <div
        className={clsx(
          showTimelineBar ? "-bottom-6" : "h-6",
          "absolute left-0 top-0 flex w-6 justify-center",
        )}
      >
        <div className="w-px bg-gray-200" />
      </div>
      <div className="relative flex h-7 w-6 flex-none items-center justify-center bg-white">
        <Icon name="copy" className="h-4 text-gray-900" />
      </div>
      <p className="flex-auto flex flex-col items-start py-0.5 text-xs leading-5 text-gray-500">
        <span className="inline-block font-medium text-gray-900">
          {getCopyMessage()}
        </span>
        <span className="relative">
          <DateTimeTz
            start={item?.createdAt}
            timezone={timezone}
            createdBy={item?.createdBy?.name}
            presentation="timeline"
          />
        </span>
      </p>
    </li>
  );
}
